import { gql } from '@apollo/client';

export const SaasCredentialBaseFields = gql`
  fragment SaasCredentialBaseFields on SaasCredential {
    id
    createdAt
    credentialType
    name
    providerName
    updatedAt
    policy {
      remove
    }
  }
`;
